var map = {
	"./AnnaData/AD_1.jpeg": 810,
	"./AnnaData/AD_logo.jpg": 6595,
	"./AnnaData/AD_logo1.png": 9598,
	"./AnnaData_bg.png": 6636,
	"./AnnaData_logo.png": 4792,
	"./BC/BC_1.jpg": 353,
	"./BC/BC_logo.jpg": 5365,
	"./BC/BC_logo1.png": 6781,
	"./BC_bg.png": 3074,
	"./BC_logo.png": 1498,
	"./BG_logo.png": 9409,
	"./Bakkani-Narasimhulu-photo-bg-download.jpg": 898,
	"./Cylcle_logo.png": 5530,
	"./HW_bg.png": 9105,
	"./HW_logo.png": 9599,
	"./HouseWater/HW_1.jpeg": 8699,
	"./HouseWater/HW_logo.jpg": 2143,
	"./HouseWater/HW_logo1.png": 4201,
	"./MS_bg.png": 5648,
	"./MS_logo.png": 9226,
	"./MahaShakti/MS_1.jpeg": 8525,
	"./MahaShakti/MS_2.jpeg": 8960,
	"./MahaShakti/MS_3.jpeg": 5403,
	"./MahaShakti/MS_4.jpeg": 1695,
	"./MahaShakti/MS_logo.jpg": 4416,
	"./MahaShakti/MS_logo1.png": 7677,
	"./NTR_logo.png": 6314,
	"./PTR_bg.png": 9293,
	"./PTR_logo.png": 5054,
	"./PoorToRich/PTR_1.jpeg": 9410,
	"./PoorToRich/PTR_logo.jpg": 7089,
	"./PoorToRich/PTR_logo1.png": 4754,
	"./Somireddy-Chandramohan-Reddy_Nominated.jpg": 8707,
	"./Yanamala-Ramakrishnudu_MLA.jpg": 1658,
	"./YuvaGalam_bg.png": 4530,
	"./YuvaGalam_logo.png": 8328,
	"./Yuvagalam/YG_1.jpg": 9373,
	"./Yuvagalam/YG_2.jpeg": 2047,
	"./Yuvagalam/YG_logo.jpg": 193,
	"./Yuvagalam/YG_logo1.png": 4640,
	"./achamnaidu.jpg": 3089,
	"./ayyana1-1.jpg": 1096,
	"./back_img.png": 9164,
	"./benefit_1.png": 6751,
	"./benefit_2.png": 9499,
	"./benefit_3.png": 5237,
	"./benefit_4.png": 2452,
	"./benefit_5.png": 1387,
	"./benefit_6.png": 1338,
	"./bg.png": 6848,
	"./bg1.png": 8950,
	"./bharosa_img.png": 3164,
	"./cbn_img.png": 7138,
	"./cbn_img1.png": 108,
	"./cbn_sign.png": 687,
	"./f-logo.png": 5692,
	"./front_img.jpeg": 1171,
	"./kolli.jpeg": 6288,
	"./kolli1.jpeg": 3020,
	"./kolli2.jpeg": 7031,
	"./leadership-icon.png": 1273,
	"./loader.gif": 7543,
	"./ntr-logo.png": 1399,
	"./panchayat_raj.png": 5917,
	"./physical_card.jpeg": 2003,
	"./red_circle.png": 694,
	"./td_janardhan_rao.jpg": 1433,
	"./tdp-logo.png": 3049,
	"./tdp-logo1.png": 807,
	"./text_bg.png": 7606,
	"./varla_ramaiah.jpg": 8260
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6303;